





import Vue from 'vue';
import { isWeiXin, getQueryString } from '@/common/ts/common';
import { getUnionId } from '@/api/api';
import qs from 'qs';
export default Vue.extend({
  data() {
    return {
      pointOut: false,
    };
  },
  created() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (window.location.hostname === 'vote.cqcb.com') {
      window.location.href = window.location.href.replace('vote.', 'activity.');
    } else {
      if (isWeiXin() && !code) {
        if (window.location.hostname === 'activity.cqcb.com') {
          window.location.href =
            'https://open.weixin.qq.com/connect/oauth2/authorize?' +
            'appid=wx1949ed4a473b87ed&' +
            'redirect_uri=' +
            encodeURIComponent(window.location.href) +
            '&response_type=code' +
            '&scope=snsapi_userinfo&' +
            'state=123#wechat_redirect';
        } else {
          console.log('开始调用微信登录');
          window.location.href =
            'https://open.weixin.qq.com/connect/oauth2/authorize?' +
            'appid=wx1949ed4a473b87ed&' +
            'redirect_uri=' +
            // encodeURIComponent(window.location.href) +
            encodeURIComponent(
              'https://activity.cqcb.com/shangyou_activity/2019q3/WeChatLogin?source=' +
                window.location.href,
            ) +
            '&response_type=code' +
            '&scope=snsapi_userinfo&' +
            'state=123#wechat_redirect';
        }
      }
    }
    if (source && code) {
      const url = decodeURIComponent(source);
      console.log('cnm', qs.parse(window.location.href));
      if ((url as any).indexOf('?') > -1) {
        window.location.href = url + '&code=' + code;
      } else {
        window.location.href = url + '?code=' + code;
      }
    }
    if (!source && code) {
      getUnionId({ code: getQueryString('code') }).then((res: any) =>
        this.successOpenId(res),
      );
    }
  },
  methods: {
    successOpenId(res: any) {
      if (res.code === 200) {
        window.localStorage.setItem('unionid', res.data.openId);
        window.localStorage.setItem('nickname', res.data.nickname);
        window.localStorage.setItem('headimgurl', res.data.headimgurl);
      } else if (res.code === 232) {
        this.$router.push(window.location.origin + window.location.pathname);
      }
    },
  },
});
